<template>
  <div>
    <list row-key="id" ref="list" unit="生产统计" :query-params="params" item-name="Items" :layout="layout" size="small" show-summary :summary-method="summaryMethod"
      :show-query="showQuery" :get-data-func="getDataFunc" @reset="reset" :center-title="centerTitle">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="success" @click="toPrint">打印</el-button>
      </template>
      <template slot="query">
        <el-form-item label="生产部门">
          <el-input v-model="DpName" class="long_inp" placeholder="请选择" @focus="openDpSelect" readonly />
        </el-form-item>
        <el-form-item label="产品批号">
          <el-input v-model="BatchNumber" class="long_inp" placeholder="请选择" @focus="openBatchPick" readonly />
        </el-form-item>
        <br>
        <el-form-item label="存货类型">
          <el-radio-group v-model="params.GroupType" style="width: 390px;">
          
            <el-radio :label="1">半成品</el-radio>
            <el-radio :label="2">配件</el-radio>
            <el-radio :label="3">成品</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="存货编码">
          <el-input v-model="ProductNo" class="long_inp" placeholder="请选择" @focus="openProductPick" readonly />
        </el-form-item>
        <br>
        <el-form-item label="商标编码">
          <el-input v-model="trademarkNo" class="long_inp" placeholder="请选择" @focus="openTrademarkPick" readonly />
        </el-form-item>
        <el-form-item label="颜色编码">
          <el-input v-model="Color" class="long_inp" placeholder="请选择" @focus="openColorPick" readonly />
        </el-form-item>
        <br>
        <el-form-item label="生产日期" style="margin-right: 219px;">
          <el-date-picker class="range-picker" v-model="dateRange" type="daterange" range-separator="~"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="onChange"
            style="width: 180px!important"></el-date-picker>
        </el-form-item>
        <el-form-item label="预计出货日期">
          <el-date-picker
            class="range-picker"
            v-model="yjchrq"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="onChange2"
            clearable
            style="width: 180px!important"
          ></el-date-picker>
        </el-form-item>
        <br>
        <el-form-item label="入库日期">
          <el-date-picker
            class="range-picker"
            v-model="rkrq"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="onChange3"
            clearable
            style="width: 180px!important"
          ></el-date-picker>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="BatchNumber" label="产品批号" min-width="180px" />
        <el-table-column prop="BarCode" label="存货条码" />
        <el-table-column prop="TrademarkName" label="部件" />
        <el-table-column prop="ColorName" label="颜色" />
        <el-table-column prop="Unit" label="单位" />
        <el-table-column prop="ProdQuantity" label="生产数量" />
        <el-table-column prop="PassQuantity2" label="合格数量" />
        <el-table-column prop="FailQuantity2" label="不合格数量" />
        <!-- <el-table-column prop="" label="g/个" /> -->
        <el-table-column prop="PassQuantity3" label="合格个数" />
        <el-table-column prop="FailQuantity3" label="不合格个数" />
        <el-table-column prop="" label="废品率" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <tree-select-dialog ref="dpTreeSelect" in-dialog @select-multiple="setDp" title="部门列表" key-id="DpId" key-name="部门名称" key-value="DpName"
      :func="dpApi.list" :default-value="dpArr" />
    <multi-pick-dialog ref="batchMultiPick" in-dialog @select-multiple="setBatch" title="产品批号列表" key-id="BatchId" key-name="产品批号" key-value="BatchNumber"
     :func="proApi.batchNumberList" :default-value="batchArr" />
    <multi-pick-dialog ref="productMultiPick" in-dialog @select-multiple="setProduct" title="存货编码列表" key-id="ProductId" key-name="存货编码" key-value="ProductNo"
     :func="proApi.list" second-name="存货名称" second-value="ProductName" :default-value="productArr" />
    <multi-pick-dialog ref="trademarkMultiPick" in-dialog @select-multiple="setTrademark" title="商标列表" key-id="TrademarkId" key-name="商标编码" key-value="TrademarkNo"
     :func="trademarkApi.list" second-name="商标名称" second-value="TrademarkName" :default-value="trademarkArr" :params="{ Status:1 }" />
    <multi-pick-dialog ref="colorMultiPick" in-dialog @select-multiple="setColor" title="颜色列表" key-id="ColorId" key-name="颜色名称" key-value="ColorName"
     :func="colorApi.list" second-name="颜色编码" second-value="ColorNo" :default-value="colorArr" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/multiList";
import treeSelectDialog from '@/components/common/treeSelectDialog';
import multiPickDialog from '@/components/common/multiPickDialog';
export default {
  mixins: [listMixin],
  components: { list, treeSelectDialog, multiPickDialog },
  //关于multiPickDialog，keyId唯一Id，keyName/Value主要字段名称/值，func列表接口，params接口参数传对象，secondName/Value第二列名称/值，select-multiple选择后的回调，defaultValue已选回显
  //关于multiList，isMerge：true时三层布局，false时二层布局，itemName第二层数组名称，itemName2第三层数组名称，layout表格上方信息布局，
  data() {
    return {
      api: require("@/api/statistics/rep").default,
      dpApi: require('@/api/ent/dp').default,
      colorApi: require('@/api/ba/color').default,
      proApi: require('@/api/ba/product').default,
      trademarkApi: require('@/api/ba/trademark').default,
      params: {
        ListDeptId: [],
        ListBatchNumber: [],
        ListProductNo: [],
        ListTrademarkNo: [],
        ListColor: [],
        GroupType: 0,
        OrderDateBegin: "",
        OrderDateEnd: "",
        OutDateBegin: "",
        OutDateEnd: "",
        InDataBegin: "",
        InDateEnd: "",
      },
      dateRange: [],
      yjchrq: [],
      rkrq: [],
      //---
      DpName: "",
      dpArr: [],
      //---
      BatchNumber: "",
      batchArr: [],
      //---
      ProductNo: "",
      productArr: [],
      //---
      trademarkNo: "",
      trademarkArr: [],
      //---
      Color: "",
      colorArr: [],
      //---
      centerTitle: "",
    };
  },
  computed: {
    layout() {
      return [
        { name: "车间代码", key: "DpNo", span: 6 },
        { name: "车间名称", key: "DpName", span: 18 },
      ];
    }
  },
  beforeMount() {
    this.reset();
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        // this.centerTitle = "各车间生产" + params.GroupType + "统计表";
        // let Data = [];
        // Data = [
        //   { FullName: "张三", TradeUnitNo: "001", OrderNo: "O001", Itsms: [{ BatchNo: "B001", ColorName: "红色", Quantity: 10 }, { BatchNo: "B002", ColorName: "绿色", Quantity: 20 }] },
        //   { FullName: "李四", TradeUnitNo: "002", OrderNo: "O002", Itsms: [{ ColorName: "白色" }] },
        // ];
        // resolve({ Data });
          this.api.repProduceSum(this.$commonJs.obj.removeNullKey(params)).then((res) => {
          let typeName = "";
          switch (params.GroupType) {
            case 0:
              typeName = "原材料";
              break;
            case 1:
              typeName = "半成品";
              break;
            case 2:
              typeName = "配件";
              break;
            case 3:
              typeName = "成品";
              break;
          }
          this.centerTitle = "各车间生产" + typeName + "统计表";
          resolve(res);
        });
      });
    },
    openDpSelect() {
      this.$refs.dpTreeSelect.open();
    },
    openBatchPick() {
      this.$refs.batchMultiPick.open();
    },
    openProductPick() {
      this.$refs.productMultiPick.open();
    },
    openTrademarkPick() {
      this.$refs.trademarkMultiPick.open();
    },
    openColorPick() {
      this.$refs.colorMultiPick.open();
    },
    setDp(e,n,m) {
      this.dpArr = e;
      this.DpName = n;
      this.params.ListDeptId = m;
    },
    setBatch(e,n) {
      this.batchArr = e;
      this.BatchNumber = n;
      this.params.ListBatchNumber = n?n.split(","):[];
    },
    setProduct(e,n) {
      this.productArr = e;
      this.ProductNo = n;
      this.params.ListProductNo = n?n.split(","):[];
    },
    setTrademark(e,n) {
      this.trademarkArr = e;
      this.trademarkNo = n;
      this.params.ListTrademarkNo = n?n.split(","):[];
    },
    setColor(e,n) {
      this.colorArr = e;
      this.Color = (e.map(x => {return x.ColorNo})).join(",");
      this.params.ListColor = n?n.split(","):[];
    },
    onChange(e) {
      this.params.OrderDateBegin = e?e[0]:"";
      this.params.OrderDateEnd = e?e[1]:"";
    },
    onChange2(e) {
      this.params.OutDateBegin = e?e[0]:"";
      this.params.OutDateEnd = e?e[1]:"";
    },
    onChange3(e) {
      this.params.InDataBegin = e?e[0]:"";
      this.params.InDateEnd = e?e[1]:"";
    },
    reset() {
      let today = this.$commonJs.getToday();
      this.dateRange = [today.substr(0, 8) + "01", today];
      this.params.OrderDateBegin = today.substr(0, 8) + "01";
      this.params.OrderDateEnd = today;
      //----
      this.DpName = "";
      this.dpArr = [];
      //----
      this.BatchNumber = "";
      this.batchArr = [];
      //----
      this.ProductNo = "";
      this.productArr = [];
      //---
      this.trademarkNo = "";
      this.trademarkArr = [];
      //----
      this.Color = "";
      this.colorArr = [];
    },
    summaryMethod(params) {
      const { columns, data } = params;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '小计';
          return;
        } else if (index > 4 && index < 10) {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = Math.floor(sums[index]);
          } else {
            sums[index] = '-';
          }
        } else {
          sums[index] = "-"
        }
      });
      return sums;
    },
    toPrint() {
      let path = "/produceStatisticPrint?type=" + this.$refs.list.tempQueryParams.GroupType;
      sessionStorage.setItem(path,JSON.stringify(this.$refs.list.data));
      let newpage = this.$router.resolve({ path });
      window.open(newpage.href, '_blank');
    },
  },
};
</script>
<style>
.long_inp .el-input__inner {
  width: 390px !important;
}
</style>